import {Pipe, PipeTransform} from "@angular/core";
import * as moment from 'moment'; // Import di moment.js

@Pipe({
  name: 'appDate'
})
export class AppDatePipe implements PipeTransform{

  transform(value: any, format: string = 'DD/MM/2024'): string | null {

    moment.locale('it');

    if (!value) {
      return null; // Gestione di valori null o undefined
    }

    // Se il valore è un oggetto Date nativo
    if (value instanceof Date) {
      return moment(value).format(format);
    }

    // Se il valore è una stringa
    if (typeof value === 'string') {
      const parsedDate = moment(value); // Parsing della stringa con moment.js
      if (parsedDate.isValid()) {
        return parsedDate.format(format);
      } else {
        return null; // La stringa non rappresenta una data valida
      }
    }

    // Se il valore è un oggetto Moment
    if (moment.isMoment(value)) {
      return value.format(format);
    }

    // Se nessuna delle condizioni è soddisfatta, ritorna null o puoi gestire un fallback
    return null;
  }

}
